import { Box } from "../Box"

import { FlagImg } from "./FlagImg"

export const FlagSquare = ({
  name,
  width,
  ratio,
  borderWidth,
  borderColor,
  borderRadius,
}) => {
  return (
    <Box
      position="relative"
      overflow="hidden"
      width={width.map(w => (typeof w === "number" ? `${w}px` : w))}
      height={width.map(w => (typeof w === "number" ? `${w}px` : w))}
      borderWidth={borderWidth}
      borderColor={borderColor}
      borderRadius={borderRadius}
    >
      <Box
        position="absolute"
        top={`-${borderWidth}px`}
        left="50%"
        transform="translateX(-50%)"
        width={width.map(w => (typeof w === "number" ? `${w * ratio}px` : w))}
      >
        <FlagImg name={name} />
      </Box>
    </Box>
  )
}
